import { render } from "./VaBeneProductListPage.vue?vue&type=template&id=ff768004&ts=true"
import script from "./VaBeneProductListPage.vue?vue&type=script&lang=ts"
export * from "./VaBeneProductListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__